import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  HALF_NAMES,
  IPeriodsTableRow,
  MONTH_NAMES,
  PERIOD_NAMES,
  QUARTER_NAMES,
  YEARS_NAMES,
} from 'components/BusinessToolForm/constants/periods';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.PRODUCTION}` as const;

export const PRODUCTION_NAMES = {
  PLANNED_PRODUCTS_VOLUME: 'plannedProductsVolume',
  SPECIFICS: 'specifics',
  PACKAGE: 'package',
  INVENTORY_MANAGEMENT: 'inventoryManagement',
  OUTSOURCING_OPPORTUNITIES: 'outsourcingOpportunities',
  INVOLVED_PRODUCTION: 'involvedProduction',
  DISPOSAL_WAIST: 'disposalWaist',
} as const;

export interface IProduction {
  [PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME]?: IPeriodsTableRow[];
  [PRODUCTION_NAMES.SPECIFICS]: string;
  [PRODUCTION_NAMES.PACKAGE]: string;
  [PRODUCTION_NAMES.INVENTORY_MANAGEMENT]: string;
  [PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES]: string;
  [PRODUCTION_NAMES.INVOLVED_PRODUCTION]: string;
  [PRODUCTION_NAMES.DISPOSAL_WAIST]: string;
}

const quarterRowInitialValues = {
  [QUARTER_NAMES.Q2]: 0,
  [QUARTER_NAMES.Q1]: 0,
  [QUARTER_NAMES.Q3]: 0,
  [QUARTER_NAMES.Q4]: 0,
};

const yearRowInitialValues = {
  [YEARS_NAMES.Y1]: 0,
  [YEARS_NAMES.Y2]: 0,
  [YEARS_NAMES.Y3]: 0,
  [YEARS_NAMES.Y4]: 0,
  [YEARS_NAMES.Y5]: 0,
};

const monthRowInitialValues = {
  [MONTH_NAMES.M1]: 0,
  [MONTH_NAMES.M2]: 0,
  [MONTH_NAMES.M3]: 0,
  [MONTH_NAMES.M4]: 0,
  [MONTH_NAMES.M5]: 0,
  [MONTH_NAMES.M6]: 0,
  [MONTH_NAMES.M7]: 0,
  [MONTH_NAMES.M8]: 0,
  [MONTH_NAMES.M9]: 0,
  [MONTH_NAMES.M10]: 0,
  [MONTH_NAMES.M11]: 0,
  [MONTH_NAMES.M12]: 0,
};

const halfRowInitialValues = {
  [HALF_NAMES.H1]: 0,
  [HALF_NAMES.H2]: 0,
  [HALF_NAMES.H3]: 0,
  [HALF_NAMES.H4]: 0,
  [HALF_NAMES.H5]: 0,
  [HALF_NAMES.H6]: 0,
};

const initialProductVolumeTableRow = {
  [PERIOD_NAMES.QUARTER_VALUES]: quarterRowInitialValues,
  [PERIOD_NAMES.MONTH_VALUES]: monthRowInitialValues,
  [PERIOD_NAMES.HALF_VALUES]: halfRowInitialValues,
  [PERIOD_NAMES.YEAR_VALUES]: yearRowInitialValues,
};

export const productionInitialValues = {
  [PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME]: [initialProductVolumeTableRow],
  [PRODUCTION_NAMES.SPECIFICS]: '',
  [PRODUCTION_NAMES.PACKAGE]: '',
  [PRODUCTION_NAMES.INVENTORY_MANAGEMENT]: '',
  [PRODUCTION_NAMES.OUTSOURCING_OPPORTUNITIES]: '',
  [PRODUCTION_NAMES.INVOLVED_PRODUCTION]: '',
  [PRODUCTION_NAMES.DISPOSAL_WAIST]: '',
};
